module.exports = {
	"sv": {
		"help-tool": {
			"button-text": "Hjälp",
			"support-button": "Få hjälp",
			"support-page": {
				"create-ticket": {
					"title": "Få hjälp",
					"instructions": "Skicka en förfrågan nedan så återkommer vi inom en vardag.",
					"related-content": {
						"title": "Detta kanske löser ditt problem"
					},
					"fields": {
						"mid": {
							"label": "Välj butik",
							"validation": "Du måste välja en butik"
						},
						"phoneNumber": {
							"label": "Telefonnummer (valfritt)"
						},
						"topic": {
							"question": "Vad är din fråga relaterad till?",
							"label": "Välj ett ämne",
							"validation": "Du måste välja ett ämne",
							"options": {
								"orders": "Beställningar",
								"settlements": "Avräkningar",
								"agreements": "Avtal",
								"others": "Övriga"
							}
						},
						"subject": {
							"label": "Ämne",
							"validation": "Du måste ange ett ämne"
						},
						"description": {
							"label": "Meddelande",
							"validation": "Du måste ange en beskrivning"
						},
						"attachment": {
							"label": "Lägg till bilaga",
							"button": "Ladda upp",
							"info": "Lägg till skärmdumpar så att vi kan lösa problemet snabbare.",
							"supportedFileTypes": "Filtyper som stöds: .png, .jpg, .pdf",
							"error": "Total filstorlek måste vara under {maxSize} MB"
						}
					},
					"submit": "Skicka förfrågan",
					"service-unavailable-error": "Oj! Något gick fel. Försök igen om några minuter. Om problemet kvarstår, {link} för hjälp.",
					"generic-error": "Vi kunde inte behandla din förfrågan. Våra system har inte kontakt med varandra just nu. Testa att uppdatera sidan eller kom tillbaka senare. Om problemet kvarstår, {link} för hjälp.",
					"contact-link": "kontakta oss"
				},
				"view-ticket": {
					"title": "Klart!",
					"details": "Vi har mottagit din förfrågan och återkommer inom en vardag. Här är din info:",
					"ticket": "Ärende #{ticketId}",
					"email": "E-postadress: {email}",
					"status": "Du kan se status för ditt ärende på vår Supportsida.",
					"track": "Se status"
				}
			},
			"header": {
				"homeLink": "Återställ"
			},
			"home": {
				"greeting": "Hej, {givenName}! Hur kan vi hjälpa dig?",
				"topics": "Vad behöver du hjälp med?"
			},
			"topics": {
				"expandButton": "Mer"
			},
			"feedback": {
				"title": "Var det här till hjälp?",
				"optionYes": "Ja, det var till hjälp",
				"optionNo": "Nej, jag behöver mer hjälp",
				"positiveFeedback": "Tack för din positiva feedback. Detta hjälper oss att erbjuda dig mer relevanta artiklar i framtiden."
			},
			"freeTextFeedback": {
				"title": "Hjälp oss att bli bättre",
				"placeholder": "Varför tyckte du inte att innehållet var användbart?",
				"submitButton": "Skicka",
				"feedbackMessage": "Tack för din feedback. Detta hjälper oss att erbjuda dig mer relevanta artiklar i framtiden."
			},
			"relatedContent": {
				"title": "Relaterat innehåll"
			},
			"search": {
				"buttonLabel": "Sök",
				"input": "Söker efter artiklar...",
				"loading": "Laddar …",
				"results": {
					"contact": "Kan du inte hitta vad du behöver?",
					"empty": "Tyvärr hittades inga resultat för din fråga. Försök att söka efter en annan term.",
					"singleTopicFound": "Vi har hittat 1 ämne",
					"multipleTopicsFound": "Vi har hittat {count} ämnen",
					"singleArticleFound": "Vi har hittat 1 artikel",
					"multipleArticlesFound": "Vi har hittat {count} artiklar"
				}
			},
			"contact": {
				"title": "Kontakta oss",
				"channelsIntro": "Hör av dig till oss så att vi kan hjälpa dig",
				"businessDetailsTitle": "Dina företagsuppgifter",
				"businessDetailsName": "Företagsnamn",
				"businessDetailsEmail": "E-post",
				"businessDetailsMid": "Handlar-id",
				"phone": {
					"title": "Ring oss",
					"paragraph": "Du kan ringa oss under arbetstid på vardagar. Om du befinner dig i Sverige eller Storbritannien kan du även ringa oss på helger mellan klockan 10-16."
				},
				"email": {
					"title": "Skicka e-post till oss",
					"paragraph": "Skicka ett e-postmeddelande så hör vi av oss så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Något gick fel",
				"message": "Vi ber om ursäkt, ett fel inträffade. Du kan klicka på knappen \"Gå tillbaka\" nedan för att gå tillbaka till hjälpverktyget eller \"Få support\"-knappen för att kontakta oss.",
				"resetButton": "Gå tillbaka",
				"errorId": "Fel-ID: {errorId}"
			},
			"tour": {
				"prev": "Föregående",
				"next": "Nästa",
				"done": "Klar"
			},
			"notAvailableMobile": {
				"title": "Ej tillgänglig",
				"buttonBack": "Tillbaka",
				"paragraph": "Detta innehåll är inte tillgängligt på din enhet. Försök att öppna det på en enhet med större skärm så som en stationär dator."
			},
			"shareButton": {
				"title": {
					"article": "Dela en djuplänk till den här artikeln",
					"topic": "Dela en djuplänk till det här ämnet",
					"tour": "Dela en djuplänk till den här rundturen"
				},
				"radioItemHome": "Hemapp",
				"descriptionHome": "Öppna hjälpartiklar på Butikportalens hemsida",
				"radioItemCurrent": "Aktuell sida",
				"descriptionCurrent": "Öppna hjälpartiklar på aktuell sida"
			},
			"marketSelector": {
				"whichMarketToContact": "Vilken marknad vill du kontakta?"
			}
		},
		"orientation": {
			"title": "Lär dig hur man..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hej {name}! 👋 Jag är din Klarna-assistent.",
				"whatDoYouNeedHelpWithPart2": "Oftast kan jag hjälpa dig på mindre än fem minuter.",
				"whatDoYouNeedHelpWithPart3": "Vad kan jag hjälpa dig med idag?",
				"selectSupportChannel": "Välj en kanal för att kontakta vår support.",
				"selectPayoutIssue": "Perfekt! Välj en fråga relaterad till utbetalningar 👇",
				"selectOrderIssue": "Perfekt! Välj en fråga relaterad till ordrar 👇",
				"capturedOrders": "Har du några {link1}-ordrar?",
				"capturedOrdersLink1": "aktiverad",
				"notPaidOrder": {
					"isScheduleFollowed": "Har du fått uppföljning på din {link1} (inkl. utbetalningsförsening)?",
					"isScheduleFollowedLink1": "utbetalningsplan",
					"isHoldbackOrDebt": "Om datumet för utbetalning passerat, kolla din {link1}. Är den pausad eller har du en skuld på grund av returer/upphävanden?",
					"isHoldbackOrDebtLink1": "senaste avräkningsfilen"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Verifiera aktiveringsdatumet för de ordrar du förväntade dig att få utbetalda och ta hänsyn till din utbetalningsförsening. Du hittar dina ordrar {link1}. Är de ordrar som du förväntar dig ska betalas ut aktiverade?",
					"isScheduleFollowedLink1": "EU-direktivet"
				},
				"changePaymentFrequency": "Har du mottagit fler än 30 aktiverade ordrar i månaden under en tremånadersperiod?",
				"whenWillGetPaid": "Betalningsdatumet kommer att bero på din utbetalningsplan och utbetalningsfördröjningen som anges i ditt kontrakt (villkor). Om du är osäker på hur din utbetalning är ordnad kan du kontrollera det på {link1}. Följs utbetalningsplanen (+utbetalningsförseningen)?",
				"whenWillGetPaidLink1": "Avräkningar",
				"thatHelped": "Tack för din positiva feedback. Detta hjälper oss att erbjuda dig mer relevant hjälp i framtiden. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Aha, jag förstår! Har du några ordrar som inte aktiverats?",
					"haveUncapturedOrdersPart2": "Om du inte vet hur du kollar detta, gå till {link1}.",
					"haveUncapturedOrdersPart2Link1": "den här sidan",
					"expirationDateSurpassed": "Har utgångsdatumet passerats? (vanligtvis 28 dagar)",
					"customerCreditPaymentMethod": "Har kunden valt kreditkortsutbetalning (faktura, konto, direktbetalning)?",
					"isOrderCaptured": "Är ordern {link1}?",
					"isOrderCapturedLink1": "aktiverad"
				}
			},
			"options": {
				"payout": "Utbetalning ",
				"orders": "Beställningar",
				"otherIssue": "Övriga frågor",
				"whenPaidOrderNext": "När får jag betalt nästa gång?",
				"notPaidOrder": "Jag har inte fått betalt",
				"paidWrongAmount": "Jag har fått fel summa utbetald",
				"changeHowOftenPaid": "Jag vill ändra hur ofta jag får utbetalningar",
				"dontKnowHowToCaptureOrder": "Jag vet inte hur jag aktiverar en order",
				"missedCaptureDeadline": "Jag missade deadline för aktivering",
				"needToRefundAnOrder": "Jag behöver återbetala en order",
				"yes": "Ja",
				"no": "Nej",
				"partially": "Delvis",
				"iNeedMoreHelp": "Jag behöver mer hjälp",
				"thatHelped": "Det hjälpte",
				"contactSupportChannel": "Kontakta supportkanaler"
			},
			"explanations": {
				"noCapturedOrders": "Först behöver du {link1}. När du har aktiverat ordern betalar vi ut summan till ditt bankkonto. Avgifter, returer och andra avgifter kommer att dras av från denna summa.",
				"noCapturedOrdersLink1": "aktivera en order",
				"feesReturnsHoldbacks": "Avgifter, returer och andra avgifter kan komma att dras av från utbetalningsbelopp. Se om du har något är pausat, om du har skuld att betala på grund av retur/återbetalning i {link1}.",
				"feesReturnsHoldbacksLink1": "senaste avräkningsfilen",
				"notPaidOrder": {
					"scheduleFollowed": "När du väl har aktiverat en order kommer vi att betala ut summan till ditt bankkonto enligt din utbetalningsplan. Avgifter, returer och andra avgifter kommer att dras av från denna summa. Se summan på utbetalning i din {link1}.",
					"scheduleFollowedLink1": "senaste avräkningsfilen",
					"noHoldback": "Se till att du har registrerat rätt bankinfo för valutan utbetalningen gäller {link1}.",
					"noHoldbackLink1": "EU-direktivet",
					"withHoldback": "Om värdet på aktiverade ordrar överstiger skulden behöver du verifiera att du har rätt bankinfo registrerad för valutan utbetalningen gäller {link1}.",
					"withHoldbackLink1": "EU-direktivet"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Du får nästa utbetalning enligt din utbetalningsplan + utbetalningsförsening."
				},
				"changePaymentFrequency": {
					"isAble": "Fortsätt genom att kontakta vår support via kanalerna nedan.",
					"isUnable": "Dessvärre uppfyller du inte kraven för att ändra din utbetalningsplan."
				},
				"orders": {
					"uncapturedDynamicYes": "Aha, jag kan se att du har {number} ordrar som inte aktiverats.",
					"uncapturedDynamicNo": "Jag kan se att du har ordrar som inte aktiverats",
					"uncapturedYesPart1": "Dags att aktivera några ordrar då! För att göra detta,",
					"uncapturedYesPart2": "1. Gå till ordersidan. {link1}.",
					"uncapturesYesPart2Link1": "genom att klicka här",
					"uncapturedYesPart3": "2. Klicka på Klarna-referenser på ordern du vill aktivera",
					"uncapturedYesPart4": "3. Välj artiklarna eller ange summan du vill aktivera",
					"uncapturedYesPart5": "4. Tryck på ”Aktivera”",
					"uncapturedNoPart1": "För att aktivera en order måste det finnas orders att aktivera.",
					"uncapturedNoPart2": "När du aktiverar en order betyder det att du bekräftar att denna skickats ut till kund. Detta ska alltid göras samma dag som ordern skickas och för varje order. När du aktiverar en order låter du också oss veta att vi ska lägga en automatisk utbetalning till dig gällande just den ordern. Läs mer om hur du aktiverar en order {link1}.",
					"uncapturedNoLink1": "EU-direktivet",
					"customerCreditPaymentMethodNo": "Tyvärr kan vi inte förlänga tiden för en order som redan utgått. Du måste skapa en ny order.",
					"expirationDateSurpassedYes": "Låt oss hjälpa dig att förlänga tiden för ordern, kontakta oss bara på supporten genom kanalerna nedan.",
					"expirationDateSurpassedNo": "Gå till {link1}. Välj ordning genom att markera rutan bredvid Klarnas referensnummer. Klicka på Förläng utgångsdatum och bekräfta din förfrågan.",
					"expirationDateSurpassedNoLink1": "Ordrar > att aktivera",
					"isOrderCapturedYesPart1": "Välj de artiklar du vill återbetala och klicka på Återbetalning.. Du kan också klicka på Återbetalning först och ange den summa du önskar återbetala – välj det sätt som fungerar bäst för dig.",
					"isOrderCapturedYesPart2": "Din kund kommer att få en återbetalning av summan de redan betalat inom 2–5 arbetsdagar. Och du kommer att se att summan dragits av från din nästa utbetalning.",
					"isOrderCapturedNo": "Om du har en order som inte aktiverats som du inte kommer att skicka kan du {link1} hela ordern. Gå till {link2} och klicka på Avbryt order.",
					"isOrderCapturedNoLink1": "avbryt",
					"isOrderCapturedNoLink2": "ordersida",
					"refundPartiallyCaptured": "Om du aktiverade ordern delvis för varor du skickade och inte kommer att skicka resten, bör du släppa den delen av ordern som inte aktiverats. Gå till {link1}, klicka på Mer och välj Släpp.",
					"refundPartiallyCapturedLink1": "ordersida"
				}
			},
			"messages": {
				"sorryToHearThat": "Det är tråkigt att höra att jag inte kunde hjälpa dig. Du blir snart kopplad till vår support."
			},
			"button": {
				"label": "Få hjälp"
			},
			"contact": {
				"chat": "Chatta med support",
				"ticket": "Skicka in förfrågan",
				"times": {
					"minutes": "Väntetid: {time} minut/minuter",
					"hours": "Väntetid: {time} timme/timmar",
					"days": "Väntetid: {time} dag/dagar"
				}
			}
		}
	}
};